import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
@Component({
  selector: 'app-elcm-condidate-from',
  templateUrl: './elcm-condidate-from.component.html',
  styleUrls: ['./elcm-condidate-from.component.scss'],
})
export class ElcmCondidateFromComponent implements OnInit {
  userName: any | null;
  loggedInUserRole: any | null;
  companyLogo: any | null;
  employeeForm: any;
  buttonColorName: any;
  getCountryList: any = []
  candidateId: any;
  companyId: any;
  currentDate: any
  addSubmitForm: boolean = false;
  year:any;
  fiscalYear: any;
  constructor(public dialog: MatDialog,public router: Router, private fb: FormBuilder, private http: HttpClient, private route: ActivatedRoute, private httpservice: HttpService, private config: Config,) {
    this.currentDate = (new Date()).toISOString();
    this.employeeForm = this.fb.group({
      // General Information
      salutation: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      gender: ['', Validators.required],
      country: ['', Validators.required],
      presentAddress: ['',Validators.required],
      permanentAddress: [''],
      maritalStatus: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      age: [''],
      personalEmail: ['', [Validators.required, Validators.email]],
      aadhaarCardNo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      panNo: ['', [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')]],
      unaNo: [''],
      mobileNo: ['', [Validators.required]],

      previousExperience: [''],
      emergencyContact: ['', [Validators.pattern('^[0-9]{10}$')]],
      bloodGroup: [''],
      fathersName: [''],
      mothersName: [''],
      spouseName: [''],
      noOfChildren: [''],
      relativeWorking: [''],

      // Education Related Information
      highestEducation: [''],
      highestEducationInstitute: [''],
      highestEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      highestEducationMarks: [''],
      secondEducation: [''],
      secondEducationInstitute: [''],
      secondEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      secondEducationMarks: [''],
      thirdEducation: [''],
      thirdEducationInstitute: [''],
      thirdEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      thirdEducationMarks: [''],
      highestProfessional: [''],
      highestProfessionalInstitute: [''],
      highestProfessionalYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      highestProfessionalMarks: [''],

      // Prior Employment Related Information
      lastOrganisation: [''],
      lastOrganisationJoiningDate: [''],
      lastOrganisationLastWorkingDate: [''],
      lastOrganisationDepartment: [''],
      lastOrganisationDesignation: [''],
      lastToLastOrganisation: [''],
      lastToLastOrganisationJoiningDate: [''],
      lastToLastOrganisationLastWorkingDate: [''],
      lastToLastOrganisationDepartment: [''],
      lastToLastOrganisationDesignation: [''],
      anyOtherOrganisation: [''],
      anyOtherOrganisationJoiningDate: [''],
      anyOtherOrganisationLastWorkingDate: [''],
      anyOtherOrganisationDepartment: [''],
      anyOtherOrganisationDesignation: ['']
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.candidateId = params['candidateId'];
      this.companyId = params['companyId'];

      console.log('Candidate ID:', this.candidateId);
      console.log('Company ID:', this.companyId);
    });
    this.userName = sessionStorage.getItem('loggedInUserName');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.companyLogo = sessionStorage.getItem('companyLogo');
    this.getAllCountryList();
    this.getData();
  }

  getData(){
    this.http.get(`${this.config.candidateGetData}?candidateId=${this.candidateId}&companyId=${this.companyId}`).subscribe((response:any)=>{
      console.log(response.data.firstName);
      this.fiscalYear=response?.data?.fiscalYear,
      this.year=response?.data?.year;
      this.employeeForm.patchValue({
        salutation:response.data.salutation,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        personalEmail: response.data.candidateEmail,
      });

    })
  }

  bloodGroups: string[] = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
  ];
  closeDialog() {

  }
  handleInput(event: any, fieldType: string) {
    const inputElement = event.target as HTMLInputElement;

    if (fieldType === 'mobile' || fieldType === 'emergencyContact') {
      // Allow only numbers and restrict length to 10
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 10) {
        event.preventDefault();
      }
    } else if (fieldType === 'pan') {
      // Convert PAN to uppercase
      inputElement.value = inputElement.value.toUpperCase();
      this.employeeForm.controls['panNo'].setValue(inputElement.value);
    } else if (fieldType === 'aadhaar') {
      // Aadhaar validation
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 12) {
        event.preventDefault();
      }
    }
  }



  hasError(controlName: string, errorType: string) {
    const control = this.employeeForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }
  getAllCountryList() {
    this.http.get("https://restcountries.com/v3.1/all").subscribe((data: any) => {
      this.getCountryList = [];
      var getCountryList = data.map((country: { name: { common: any; }; }) => country.name.common);
      getCountryList?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getCountryList.push(obj);
      });
      this.getCountryList = this.getCountryList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
      console.log(this.getCountryList);

    })
  }

  calculateAgeFromDOB() {
    const dob = new Date(this.employeeForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.employeeForm.controls['age'].setValue(age);
  }

   getFiscalYearDynamic(): { fiscalYearFormat: string; year: string } {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // JavaScript months are 0-indexed
  
    // Determine fiscal year type dynamically (fetch from API, DB, or config)
    const startMonth = this.getConfiguredFiscalYearStartMonth(); // Dynamically fetch this value
  
    let fiscalYearFormat = "";
    let fiscalYear = "";
  
    if (startMonth === 1) {
      fiscalYearFormat = "Jan_Dec";
      fiscalYear = `${year}-${year + 1}`;
    } else if (startMonth === 4) {
      fiscalYearFormat = "Apr_Mar";
      fiscalYear = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
    } else {
      throw new Error("Unsupported fiscal year start month. Use 1 for Jan-Dec or 4 for Apr-Mar.");
    }
  
    return { fiscalYearFormat, year: fiscalYear };
  }
  
  // **Mock function to fetch fiscal start month dynamically (Replace with API call or config)**
   getConfiguredFiscalYearStartMonth(): number {
    // Example: Fetch from an API or config file
    return 4; // Change dynamically based on your business logic
  }
  
  // **Usage**
 
  


  saveEmployeeeData() {
    console.log(this.employeeForm)
    const fiscalYearData = this.getFiscalYearDynamic();
    console.log(fiscalYearData); // Example output: { fiscalYearFormat: 'Apr_Mar', year: '2024-2025' }
    let employeeFromData = this.employeeForm.value;
    let formData = {
      "fiscalYear": this.fiscalYear,
      "year":this.year,
      "companyId": parseInt(this.companyId),
      "candidateId": parseInt(this.candidateId),

      "gender": employeeFromData.gender,
      "address": employeeFromData.presentAddress,
      "permanentAddress": employeeFromData.permanentAddress,
      "country": employeeFromData.country,
      "maritalStatus": employeeFromData.maritalStatus,
      "dateOfBirth": employeeFromData.dateOfBirth,
      "age": employeeFromData.age,
      "aadharNo": employeeFromData.aadhaarCardNo,
      "panNo": employeeFromData.panNo,
      "uan": employeeFromData.unaNo,
      "contactNo": employeeFromData.mobileNo,
      "totalExperience": employeeFromData.previousExperience,
      "emergencyContactNo": employeeFromData.emergencyContact,
      "bloodGroup": employeeFromData.bloodGroup,
      "fathersName": employeeFromData.fathersName,
      "mothersName": employeeFromData.mothersName,
      "spouseName": employeeFromData.spouseName,
      "noOfChildren": employeeFromData.noOfChildren,
      "isRelativeWorking": false,

      // Education Information
      "highestEducationQualification": employeeFromData.highestEducation,
      "highestEducationInstitute": employeeFromData.highestEducationInstitute,
      "highestEducationYearOfPassing": employeeFromData.highestEducationYearOfPassing,
      "highestEducationMarks": employeeFromData.highestEducationMarks,

      "highestEducationQualification2": employeeFromData.secondEducationInstitute,
      "highestEducationInstitute2": employeeFromData.secondEducationInstitute,
      "highestEducationYearOfPassing2": employeeFromData.secondEducationYear,
      "highestEducationMarks2": employeeFromData.secondEducationMarks,

      "highestEducationQualification3": employeeFromData.thirdEducation,
      "highestEducationInstitute3": employeeFromData.thirdEducationInstitute,
      "highestEducationYearOfPassing3": employeeFromData.thirdEducationYear,
      "highestEducationMarks3": employeeFromData.thirdEducationMarks,

      "highestProfessionalQualification": employeeFromData.highestProfessional,
      "highestProfessionalInstitute": employeeFromData.highestProfessionalInstitute,
      "highestProfessionalYearOfPassing": employeeFromData.highestProfessionalYearOfPassing,
      "highestProfessionalMarks": employeeFromData.highestProfessionalMarks,

      // Prior Employment Information
      "lastOrganisationName": employeeFromData.lastToLastOrganisation,
      "lastOrganisationDoj": employeeFromData.lastOrganisationJoiningDate,
      "lastOrganisationLwd": employeeFromData.lastOrganisationLastWorkingDate,
      "lastOrganisationDepartment": employeeFromData.lastOrganisationDepartment,
      "lastOrganisationDesignation": employeeFromData.lastOrganisationDesignation,

      "lastToLastOrganisationName": employeeFromData.lastOrganisation,
      "lastToLastOrganisationDoj": employeeFromData.lastToLastOrganisationJoiningDate,
      "lastToLastOrganisationLwd": employeeFromData.lastToLastOrganisationLastWorkingDate,
      "lastToLastOrganisationDepartment": employeeFromData.lastToLastOrganisationDepartment,
      "lastToLastOrganisationDesignation": employeeFromData.lastToLastOrganisationDesignation,

      "otherOrganisationName": employeeFromData.anyOtherOrganisation,
      "otherOrganisationDoj": employeeFromData.anyOtherOrganisationJoiningDate,
      "otherOrganisationLwd": employeeFromData.anyOtherOrganisationLastWorkingDate,
      "otherOrganisationDepartment": employeeFromData.anyOtherOrganisationDepartment,
      "otherOrganisationDesignation": employeeFromData.otherOrganisationDesignation,

      "mailSubject": "reply ",
      "mailBody": " "

    }
    if (this.employeeForm.invalid) {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
    }

    if (this.employeeForm.valid) {
      this.httpservice.callPostServiceForLogin(this.config.candidateCreateform, formData).subscribe((data: any) => {
      //   if (data) {
      //     this.router.navigate(['welcome']);
      //   }
      // })

      if (data) {

        this.router.navigate(['welcome']);

      }
    },
      (error: any) => {
console.log(error);

        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg:error?.error?.message || error?.error.details,
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      })
    }
  }
}


